export default __webpack_public_path__ + "static/media/Mark-4-Suit-04.34c5ebd2.jpg";